import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useTheme } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useState } from 'react';

import FileAttachmentPreviewDialog from '~components/Files/FileAttachmentPreviewDialog';
import useOrderFileAttachmentsQuery from '~queries/useOrderFileAttachmentsQuery';

interface OrderCardAttachmentPreviewProps {
  attachmentCount: number;
  orderId: string;
  orderNumber: string;
}

export default function OrderCardAttachmentPreview({
  attachmentCount,
  orderId,
  orderNumber,
}: OrderCardAttachmentPreviewProps) {
  const theme = useTheme();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const { attachments, isError, isFetching } = useOrderFileAttachmentsQuery({
    enabled: isPreviewOpen,
    orderId,
  });

  return (
    <>
      <IconButton
        aria-label={t('file_attachments.preview_attachments')}
        data-test-id={`order-card-attachments-${orderNumber}`}
        onClick={(event) => {
          event.stopPropagation();
          setIsPreviewOpen(true);
        }}
        size="small"
        sx={{ p: 0.25 }}
      >
        <Typography
          component="span"
          variant="body2"
          sx={{
            alignItems: 'center',
            color: theme.brandV2.colors.treadGreen,
            display: 'flex',
          }}
        >
          <AttachFileIcon fontSize="small" />
          {attachmentCount}
        </Typography>
      </IconButton>

      {isPreviewOpen && (
        <FileAttachmentPreviewDialog
          attachments={attachments}
          isError={isError}
          isFetching={isFetching}
          isOpen
          onClose={() => setIsPreviewOpen(false)}
        />
      )}
    </>
  );
}
